const gridItemStyle = {
  grid: {
    padding: '0 15px !important'
  }
};

export default gridItemStyle;
